import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Notification, NotificationType } from '../../store/notification/types';
import { NotificationService } from '../../store/notification/notification.service';

@Component({
    selector: 'app-toast-validation',
    templateUrl: './toast-validation.component.html',
    styleUrls: ['./toast-validation.component.scss'],
    standalone: false
})
export class ToastValidationComponent implements OnInit {
  notifications$: Observable<Notification[]>;

  constructor(private readonly notificationService: NotificationService) {}

  ngOnInit(): void {
    this.notifications$ = this.notificationService.getNotifications();
  }

  remove(notification: Notification) {
    this.notificationService.remove(notification);
  }

  protected readonly NotificationType = NotificationType;
}
